import React, { Fragment } from "react"
import { MdClose } from "react-icons/md"

import classes from "./CdsCheckoutSpecifications.module.scss"

const CdsCheckoutSpecifications = props => {
  const { specificationItem, orderItemQuantity } = props

  return (
    <div className={classes["container"]}>
      <div className={classes["row"]}>
        <b className={classes["name"]}>
          {specificationItem.name}
        </b>

        {
          !specificationItem.isSelectable &&
          <Fragment>
            <MdClose />
            <b className={classes["qty"]}>
              {specificationItem.quantity * orderItemQuantity}
            </b>
          </Fragment>
        }
      </div>
    </div>
  )
}

export default CdsCheckoutSpecifications